<template>
    <div id="ContainerProvider">
        <div class="container-scroller">
            <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div class="content-wrapper d-flex align-items-center auth px-0">
                    <div class="row w-100 mx-0">
                        <div class="col-lg-4 mx-auto">
                            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
                                <div class="brand-logo">
                                    <img src="../../../assets/images/logo.svg" alt="logo" />
                                    <a
                                        v-on:click="logout"
                                        role="button"
                                        class="btn btn-light btn-sm float-right text-truncate mt-2"
                                        >{{ $t('AccountExpired.BtLogin') }}</a
                                    >
                                </div>
                                <noscript>
                                    <div class="alert alert-fill-warning" role="alert">
                                        <i class="mdi mdi-alert-circle"></i>
                                        {{ $t('Msg.EnableJsMsg') }}
                                    </div>
                                </noscript>
                                <h6 class="font-weight-light">
                                    {{ $t('SelectProvider.SelectProv') }}
                                </h6>
                                <div class="pt-3">
                                    <div
                                        id="alert"
                                        class="alert alert-fill-danger hidden"
                                        role="alert"
                                    >
                                        <i class="mdi mdi-alert-circle"></i>
                                        {{ $t('SelectProvider.NoWorkingMsg') }}
                                    </div>
                                    <div class="btn-group btn-block mb-4" dir="ltr">
                                        <button
                                            id="provider"
                                            type="button"
                                            class="btn btn-light btn-block text-truncate"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="true"
                                        >
                                            <i class="mdi mdi-playlist-check text-muted"></i>
                                            {{ $t('SelectProvider.NoProvSelectMsg') }}
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-success dropdown-toggle dropdown-toggle-split"
                                            id="providers"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <input
                                                ref="uprovider"
                                                id="provider-value"
                                                type="hidden"
                                            />
                                            <span class="sr-only">{{
                                                $t('SelectProvider.ToggleDropdown')
                                            }}</span>
                                        </button>
                                        <div
                                            class="dropdown-menu dropdown-menu-right shadow scrollmenu cutescroll"
                                            aria-labelledby="providers"
                                        >
                                            <h6 class="dropdown-header font-weight-bold">
                                                {{ $t('SelectProvider.Providers') }}
                                            </h6>
                                            <div class="dropdown-divider"></div>
                                            <span
                                                v-for="provider in providerList"
                                                :key="provider.code"
                                                class="dropdown-item text-success font-weight-bold text-truncate pointer"
                                                v-on:click="
                                                    passItem(
                                                        'provider',
                                                        provider.code + '-' + provider.company
                                                    )
                                                "
                                            >
                                                {{ provider.code }} -
                                                {{ provider.company }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <MdButton
                                            v-bind:Label="$t('SelectProvider.ENTER')"
                                            v-bind:Name="'btnEnter'"
                                            v-bind:ClassProp="
                                                'btn btn-block btn-primary btn-login btn-lg font-weight-medium auth-form-btn text-truncate'
                                            "
                                            v-on:click="main"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProviderService from '@/services/provider.service';
import UserService from '@/services/user.service';
import UserPreferences from '@/services/userpreferences.service';
import StorageService from '@/services/storage.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import PermFunctions from '@/common/PermFunctions.js';
import DBFunctions from '@/common/DBFunctions.js';
import store from '@/globalvar.js';
import UtilsService from '@/services/utils.service';
import LabService from '@/services/lab.service';
import NewCropService from '@/services/newcrop.service';

export default {
    name: 'Provider',
    mixins: [ShowMessage, PermFunctions, DBFunctions],
    data() {
        return {
            Loading: true,
            selected: null,
            CodeSelected: {
                ProviderId: ''
            },
            providerList: this.$store.state.ProvidersList,
            isUseLab: false
        };
    },

    methods: {
        logout() {
            this.$bvModal
                .msgBoxConfirm(this.$t('SelectProvider.CloseSessionMsg'), {
                    title: this.$t('Shared.Logout'),
                    okTitle: this.$t('Shared.LogOut'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    this.IsOk = value;
                    if (this.IsOk) {
                        UserService.logout()
                            .then(response => {
                                if (response.status == '200') {
                                    this.$store.commit('setAccessToken', '');
                                    localStorage.removeItem('vuex');
                                    localStorage.removeItem('_secure__ls__metadata');
                                    this.$router.push('/login').catch(() => {});
                                }
                            })
                            .catch(error => {
                                if (!error.response) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('SelectProvider.NoAbleToLogOutMsg'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(this.$tc('Msg.Error'), error, 'error');
                                }
                            });
                    }
                });
        },

        getRestrictions() {
            const uid = StorageService.getUserId();
            UtilsService.getUserRestrictions(uid)
                .then(response => {
                    if (response.status == '200') {
                        const restrictions = response.data;
                        if (
                            restrictions.requiredBuildingLocation ||
                            restrictions.requiredPharmacy ||
                            restrictions.requiredProgram
                        ) {
                            this.SelectUserRestrictions(restrictions);
                        } else {
                            this.$router.push('/app/main');
                        }
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        SelectUserRestrictions(restrictions) {
            this.$store.commit('setRequiredBuildingLocation', restrictions.requiredBuildingLocation);
            this.$store.commit('setRequiredBuildingLocationList', restrictions.buildingList);
            this.$store.commit('setRequiredPharmacy', restrictions.requiredPharmacy);
            this.$store.commit('setRequiredPharmacyList', restrictions.pharmacyList);
            this.$store.commit('setRequiredProgram', restrictions.requiredProgram);
            this.$store.commit('setRequiredProgramList', restrictions.programList);
            this.$store.commit('setAllowMultiProgram', restrictions.allowMultiProgram);

            let model = {
                building: [],
                pharmacy: [],
                programs: []
            };
            let redirectToRestrictions = false;

            if (restrictions.requiredBuildingLocation) {
                if (restrictions.buildingList.length === 1) {
                    model.building = restrictions.buildingList;
                } else {
                    redirectToRestrictions = true;
                }
            }

            if (!redirectToRestrictions && restrictions.requiredPharmacy) {
                if (restrictions.pharmacyList.length === 1) {
                    model.pharmacy = restrictions.pharmacyList;
                } else {
                    redirectToRestrictions = true;
                }
            }

            if (!redirectToRestrictions && restrictions.requiredProgram) {
                if (restrictions.programList.length === 1) {
                    model.programs = restrictions.programList;
                } else {
                    redirectToRestrictions = true;
                }
            }

            if (redirectToRestrictions) {
                this.$router.push('/restrictions');
            } else {
                /*this.$store.commit('setRestrictions',{
          buildingLocation: model.building,
          pharmacy: model.pharmacy,
          programs: model.programs,
        });
        this.$router.push('/app/main');*/
                ProviderService.SetUserRestrictions({
                    buildings: model.building,
                    pharmacies: model.pharmacy,
                    programs: model.programs
                })
                    .then(response => {
                        if (response.status == '200') {
                            this.$store.commit('setRedirectToRestrictions', false);
                            store.commit('setAccessToken', JSON.stringify(response.data));
                            this.$router.push('/app/main');
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            }
        },

        SelectProvider() {
            ProviderService.SelectProvider(this.CodeSelected)
                .then(response => {
                    if (response.status == '200') {
                        store.commit('setVip', response.data.isVIP);
                        // store.commit('setSpecialCase',response.data.isSpecialCase);
                        store.commit('setAccessToken', JSON.stringify(response.data));
                        this.setPermissions();
                        // this.PupulateSelects();
                        //this.$router.push('/app/main');
                        this.CheckUseLab();
                        this.CheckUseNewCrop();
                        ProviderService.ensureVisibleSettings();
                        this.getRestrictions();
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async CheckUseLab() {
            await LabService.checkUseLab()
                .then(response => {
                    this.isUseLab = response.data;
                    this.$store.commit('setProviderUseLab', this.isUseLab);
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async CheckUseNewCrop() {
            await NewCropService.checkUseNewCrop()
                .then(response => {
                    this.$store.commit('setProviderUseNewCrop', response.data);
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        main() {
            const p = this.$refs.uprovider.value;
            if (p) {
                const providercode = p.split('-')[0];
                const provider = p.split('-')[1];
                this.$store.commit('setProviderCode', providercode);
                this.$store.commit('setProvider', provider);
                this.CodeSelected.ProviderId = providercode;
                this.SelectProvider();
            }
        },

        passItem(toMenu, fromItem) {
            document.getElementById(toMenu).innerHTML =
                '<i class="mdi mdi-check text-success"></i> ' + fromItem;
            document.getElementById(toMenu + '-value').value = fromItem;
        },

        getUserPreference() {
            const userid = StorageService.getUserId();
            UserPreferences.getUserPreference(userid)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        var dataResponse = response.data[0];
                        if (dataResponse.providerCode && dataResponse.providerCode != 0) {
                            this.passItem(
                                'provider',
                                dataResponse.providerCode + '-' + dataResponse.company
                            );
                        }
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        }
    },

    mounted() {
        this.providerList = this.$store.state.ProvidersList;
        this.getUserPreference();
    }
};
</script>
